export default "__VITE_ASSET__B84de24d__"